import axios from "axios";
export const api = axios.create({ baseURL: "/api/v1", withCredentials: true, withXSRFToken: true, headers: { Accept: "application/json" } });
export async function csrf() { await axios.get("/sanctum/csrf-cookie", { withCredentials: true }); }
